import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, SxProps, TextField, Theme } from '@mui/material';

interface SearchFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** When the typed text is enough to search. */
  rule: (value: string) => boolean;
  /** What to say until it is. */
  tooShort: string;
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

/** Searches match any part of a name; * skips any text between two parts. */
export const SEARCH_TIP = 'Tip: * skips any text between parts';

/** A search box with a clear button, hinting until the search is long enough to run. */
const SearchField = ({ label, value, onChange, rule, tooShort, fullWidth, sx }: SearchFieldProps) => {
  const short = value.trim().length > 0 && !rule(value);
  return (
    <TextField
      size="small"
      label={label}
      value={value}
      fullWidth={fullWidth}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onChange('');
      }}
      helperText={short ? tooShort : SEARCH_TIP}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" edge="end" aria-label={`Clear ${label.toLowerCase()}`} onClick={() => onChange('')}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null
      }}
    />
  );
};

export default SearchField;
